import type { ActionSource } from 'owa-analytics-types';
import { resetFocus } from 'owa-mail-focus-manager';
import { undo } from 'owa-mail-undo';

export default function onUndo(actionSource: ActionSource): void {
    undo(actionSource);
    resetFocus('undoCommand');
}
